import React from 'react';
import { Tag } from '@bb/elements-web';
import styled from 'styled-components';

/** A tag component used to display card errors on the subscription and payments page. */
export const CardErrorTag: React.FC = ({ children }) => (
  <StyledTag color="danger" dataCy="card-error-tag">
    {children}
  </StyledTag>
);

const StyledTag = styled(Tag)`
  font-size: 16px;
`;
